const handler = {
  updateLogging(state, payload) {
    // 合并现有的 dataWareHouse 和新的 payload
    state.dataWareHouse = {
      ...state.dataWareHouse,
      ...payload
    };
  },
  clearLogging(state) {
    state.dataWareHouse = {};
  },
  getLocation(state) {
    return state.dataWareHouse.location;
  }
};
export default handler;